export default __webpack_public_path__ + "static/media/aequalis27.9e1df420.pdf";